import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { ADORNMENT_TYPES } from "./constants";
import { BaseAdornmentWrapper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AdornmentWrapper(_ref) {
  var adornmentProps = _ref.adornmentProps,
    side = _ref.side;
  var type = adornmentProps.type,
    props = adornmentProps.props;
  var Component = ADORNMENT_TYPES[type] || ADORNMENT_TYPES["default"];
  return /*#__PURE__*/_jsx(BaseAdornmentWrapper, {
    children: /*#__PURE__*/_jsx(Component, _extends({
      side: side
    }, props))
  });
}